<template>
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div class="card-header">
      <h3 class="text-black fw-semibold">Liste des clients affectés</h3>
    </div>
    <div
      class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25"
    >
      <div class="d-sm-flex align-items-center">
        <router-link
          class="btn btn-primary"
          to="/clientAffecter/ajouter-clientAffecter"
        >
          <i class="fa fa-plus-circle"></i>
          Ajouter une affectation
        </router-link>
      </div>
      <div class="d-flex align-items-center">
        <form class="search-bg svg-color pt-3" @submit.prevent="rechercher">
          <input
            type="text"
            v-model="searchTerm"
            @keyup="rechercher"
            class="form-control shadow-none text-black"
            placeholder="Rechercher une affectation"
          />
          <button
            type="submit"
            class="bg-transparent text-primary transition p-0 border-0"
          >
            <i class="flaticon-search-interface-symbol"></i>
          </button>
        </form>
      </div>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25">
      <div class="table-responsive">
        <table class="table text-nowrap align-middle mb-0">
          <thead>
            <tr>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-beginning pe-0"
              >
                Utilisateur
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-beginning pe-0"
              >
                Clients
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 pe-0"
              >
                Actions
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(userGroup, index) in groupedClientAffecters" :key="index">
              <td class="shadow-none lh-1 fw-medium">
                {{ userGroup.user?.nom }} {{ userGroup.user?.prenom }}
              </td>
              <td class="shadow-none lh-1 fw-medium">
                <span
                  v-for="(clientAffecter, clientIndex) in userGroup.clients"
                  :key="clientIndex"
                  class="d-flex align-items-center mb-2"
                >
                  <span class="badge badge-primary me-2">
                    {{
                      clientAffecter.client.nomClient && clientAffecter.client.prenomClient
                        ? `${clientAffecter.client.nomClient} ${clientAffecter.client.prenomClient}`
                        : clientAffecter.client.raisonSociale
                    }}
                  </span>
                  <div v-if="clientIndex !== 0" class="ms-3">
                    <span class="btn f-w-500 background-light-danger font-danger p-0">
                      <a class="d-flex align-items-center text-danger" href="javascript:void(0);"
                         @click="suppClientAffecter(clientAffecter.id)">
                        <i class="fa fa-trash-o lh-2 me-8 position-relative top-1"></i>
                      </a>
                    </span>
                  </div>
                </span>
              </td>
              <td class="shadow-none lh-1 fw-medium text-body-tertiary pe-0">
                <div class="dropdown">
                  <button
                    class="btn dropdown-toggle btn-primary"
                    type="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    Actions
                  </button>
                  <ul class="dropdown-menu">
                    <li class="dropdown-item d-flex align-items-center">
                      <a
                        href="#"
                        data-bs-toggle="modal"
                        data-bs-target="#AddClientModal"
                        @click="openAddClientModal(userGroup.user)"
                      >
                        <i class="fa fa-lock lh-2 me-8 position-relative top-1"></i>
                        Ajouter un client
                      </a>
                    </li>
                    <li class="dropdown-item d-flex align-items-center">
                      <a
                        href="javascript:void(0);"
                        @click="suppression(userGroup.clients[0].id, clientAffecters, 'clientAffecter', 'une affectation client')"
                      >
                        <i class="fa fa-trash-o lh-1 me-8 position-relative top-1"></i>
                        Supprimer
                      </a>
                    </li>
                  </ul>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div
        class="pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center"
      >
        <PaginationComponent
          :page="page"
          :totalPages="totalPages"
          :totalElements="totalElements"
          :limit="limit"
          @paginate="handlePaginate"
        />
      </div>
    </div>
  </div>
  <AddClientModal :selectedUser="selectedUser" @close="rechercher" />
</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from 'vue';
import ApiService from '@/services/ApiService';
import { ClientAffecter, User } from '@/models/ClientAffecter';
import { suppression, error, success } from '@/utils/utils';
import PaginationComponent from '@/components/Utilities/Pagination.vue';
import JwtService from '@/services/JwtService';
import AddClientModal from './AddClientModal.vue';

export default defineComponent({
  name: 'ListeClientAffecter',
  components: {
    PaginationComponent,
    AddClientModal,
  },
  setup() {
    onMounted(() => {
      getAllClientAffecter();
    });

    const clientAffecters = ref<Array<ClientAffecter>>([]);
    const groupedClientAffecters = ref<Array<{ user: any; clients: ClientAffecter[] }>>([]);
    const clientAffecter = ref<ClientAffecter>();
    const selectedUser = ref<User | undefined>(undefined);
    const selectedUserId = ref<number>();

    // BEGIN PAGINATE
    const searchTerm = ref('');
    const page = ref(1);
    const totalPages = ref(0);
    const limit = ref(10);
    const totalElements = ref(0);

    const handlePaginate = ({ page_, limit_ }: { page_: number; limit_: number }) => {
      try {
        page.value = page_;
        getAllClientAffecter(page_, limit_);
      } catch (err) {
        //
      }
    };

    const openAddClientModal = (user: User) => {
      selectedUser.value = { ...user };
      selectedUserId.value = typeof user.id == 'string' ? parseInt(user.id) : user.id;
      console.log('user selected ', selectedUser.value);
    };

    function rechercher() {
      getAllClientAffecter(page.value, limit.value, searchTerm.value);
    }

    function getAllClientAffecter(page = 1, limi = 10, searchTerm = '') {
      return ApiService.get(`/all/clientAffecter?page=${page}&limit=${limi}&mot=${searchTerm}`)
        .then(({ data }) => {
          console.log('Données reçues:', data);
          clientAffecters.value = data.data.data;
          totalPages.value = data.data.totalPages;
          limit.value = data.data.limit;
          totalElements.value = data.data.totalElements;

          // Regroupement par utilisateur
          const groupedByUser = clientAffecters.value.reduce((acc, affecter) => {
            // Vérifiez si user existe et est un objet
            if (affecter.user && typeof affecter.user === 'object' && 'id' in affecter.user) {
              const userId = affecter.user.id as string | number;
              if (!acc[userId]) {
                acc[userId] = {
                  user: affecter.user,
                  clients: [],
                };
              }
              acc[userId].clients.push(affecter);
            }
            return acc;
          }, {} as Record<string | number, { user: any; clients: ClientAffecter[] }>);

          groupedClientAffecters.value = Object.values(groupedByUser);

          return data.data.data;
        })
        .catch(({ response }) => {
          //error(response?.data?.message || 'Erreur lors de la récupération des affectations');
        });
    }

    const suppClientAffecter = async (id: any) => {
      try {
        const { data } = await ApiService.delete(`/clientAffecter/${id}`);
        if (data.code === 200) {
          success(data.message);
          getAllClientAffecter(page.value, limit.value, searchTerm.value); // Rafraîchir la liste
        }
      } catch (err) {
        error(err instanceof Error ? err.message : "Erreur lors de la suppression de l'affectation.");
      }
    };

    const privileges = ref<Array<string>>(JwtService.getPrivilege());

    const checkPermission = (name: string) => {
      return privileges.value.includes(name);
    };

    return {
      checkPermission,
      suppression,
      suppClientAffecter,
      clientAffecters,
      openAddClientModal,
      groupedClientAffecters,
      page,
      totalPages,
      limit,
      totalElements,
      handlePaginate,
      searchTerm,
      rechercher,
      selectedUserId,
      selectedUser,
    };
  },
});
</script>